var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSureIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F4EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2578 21.2422C9.53906 20.5234 10.0156 19.0156 9.64844 18.1328C9.28125 17.25 7.875 16.4766 7.875 15.5C7.875 14.5234 9.26563 13.7813 9.64844 12.8672C10.0313 11.9531 9.53906 10.4766 10.2578 9.75781C10.9766 9.03906 12.4844 9.51563 13.3672 9.14844C14.25 8.78125 15.0234 7.375 16 7.375C16.9766 7.375 17.7187 8.76563 18.6328 9.14844C19.5469 9.53125 21.0234 9.03906 21.7422 9.75781C22.4609 10.4766 21.9844 11.9844 22.3516 12.8672C22.7188 13.75 24.125 14.5234 24.125 15.5C24.125 16.4766 22.7344 17.2187 22.3516 18.1328C21.9688 19.0469 22.4609 20.5234 21.7422 21.2422C21.0234 21.9609 19.5156 21.4844 18.6328 21.8516C17.75 22.2188 16.9766 23.625 16 23.625C15.0234 23.625 14.2813 22.2344 13.3672 21.8516C12.4531 21.4688 10.9766 21.9609 10.2578 21.2422Z",
    stroke: "#7434DB",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.3252C16.1312 19.3252 16.2373 19.4313 16.2373 19.5625C16.2373 19.6937 16.1312 19.7998 16 19.7998C15.8688 19.7998 15.7627 19.6937 15.7627 19.5625C15.7627 19.4313 15.8688 19.3252 16 19.3252Z",
    fill: "#7434DB",
    stroke: "#7434DB",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.75V16.125C16.4326 16.125 16.8556 15.9967 17.2153 15.7563C17.575 15.516 17.8554 15.1743 18.021 14.7746C18.1866 14.3749 18.2299 13.9351 18.1455 13.5107C18.0611 13.0864 17.8527 12.6966 17.5468 12.3907C17.2409 12.0848 16.8511 11.8764 16.4268 11.792C16.0024 11.7076 15.5626 11.7509 15.1629 11.9165C14.7632 12.0821 14.4215 12.3625 14.1812 12.7222C13.9408 13.0819 13.8125 13.5049 13.8125 13.9375",
    stroke: "#7434DB",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSureIcon);
export default __webpack_public_path__ + "static/media/sure_icon.25c00d2d0d8dbd2be5ae44d5748e6a20.svg";
export { ForwardRef as ReactComponent };